import Config from 'common-src/config';

export const AthenaDepartment = {
  NeurologyDanvers: {
    id: 1,
    value: 'Neurology Danvers',
    label: 'Danvers',
  },
  GUIDE: {
    id: 2,
    value: 'GUIDE',
    label: 'GUIDE',
  },
  NeurologyOrangeCounty: {
    id: 4,
    value: 'Neurology Orange County',
    label: 'Downey',
  },
  NeurologyBayArea: {
    id: 5,
    value: 'Neurology Bay Area',
    label: 'San Jose',
  },
  NeurologyLongBeach: {
    id: 6,
    value: 'Neurology Long Beach',
    label: 'Long Beach',
  },
  TestDepartment: {
    id: 3,
    value: 'Test Department',
    label: 'Test Department',
  },
};

export const AthenaDepartmentsOptions = Object.values(AthenaDepartment).map((department) => ({
  label: department.label,
  value: department.value,
}));

export const AthenaDepartmentIdOptions = Object.values(AthenaDepartment).map((department) => ({
  label: department.label,
  value: `${department.id}`,
}));

export const normalizeAthenaDepartment = (department) => {
  const id = department?.athenaDepartmentId ?? department?.athena_department_id ?? department?.id;
  const name =
    department?.name ??
    department?.departmentName ??
    department?.departmentname ??
    department?.value;
  if (id == null || !name) return null;

  const label = department?.label ?? name;
  return {
    id: `${id}`,
    value: name,
    label,
    active: department?.active ?? true,
    timezone: department?.timezone ?? null,
  };
};

export const normalizeAthenaDepartments = (departments) =>
  (Array.isArray(departments) ? departments : [])
    .map(normalizeAthenaDepartment)
    .filter(Boolean)
    .filter((department) => department.active !== false);

export const getAthenaDepartmentOptions = (departments) =>
  normalizeAthenaDepartments(departments).map((department) => ({
    label: department.label,
    value: department.value,
    id: department.id,
  }));

export const getAthenaDepartmentIdOptions = (departments) =>
  normalizeAthenaDepartments(departments).map((department) => ({
    label: department.label,
    value: `${department.id}`,
  }));

export const getAthenaDepartmentLabelById = (departments) =>
  normalizeAthenaDepartments(departments).reduce((acc, department) => {
    acc[`${department.id}`] = department.label;
    return acc;
  }, {});

export const getAthenaDepartmentLabelByValue = (departments) =>
  normalizeAthenaDepartments(departments).reduce((acc, department) => {
    acc[department.value] = department.label;
    return acc;
  }, {});

export const isTestAthenaDepartment = (department) =>
  `${department?.id ?? ''}` === `${AthenaDepartment.TestDepartment.id}` ||
  `${department?.value ?? department?.label ?? ''}`.toLowerCase() === 'test department';

export const AthenaPracticeOptions = [JSON.parse(Config.ATHENA_MINDSPAN_GROUP_PRACTICE)];

export const AthenaCustomFieldIds = {
  member_id: '32',
  pcp_first_name: '25',
  pcp_last_name: '26',
  pcp_phone_number: '27',
  legacy_patient_id: '1',
};
